import React from 'react';
import { History } from 'history';
import { Input, InputEmail, InputFile, InputPassword, InputSwitch, InputPicklist } from '../../components';
import BaseCreate from '../base/base-create.component'; 
import Model from './user-model';  //editable..
import MedialibraryModel from '../medialibrary/medialibrary-model';
import OwnerPicklist from '../owner/owner-picklist.component';
import AppService from '../../services/app.service';
import PersonalinfoCreate from '../personalinfo/personalinfo-create.component';

interface IProps { 
    history: History;
}

interface IState {
    datarow: Model;
    errors: any;
    datarowMedia: any;
    datarowPersonalinfo: any,
    save: boolean;
}

export default class UserCreate extends  React.Component<IProps, IState> {
    constructor(props:IProps) {
        super(props);  
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
            datarowMedia: null,
            datarowPersonalinfo: null,
            save: false,
        }
        this.onChange = this.onChange.bind(this);
    }

    private onLoadOwner = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'owner': data?.id, 'ownerCaption': data?.name || ''  }  });
    }

    private onLoadFile = (data: any) => {
        this.setState({datarowMedia: {...this.state.datarowMedia, endPoint: MedialibraryModel.endPoint, endPointDelete: MedialibraryModel.endPoint2, datarow:{id:this.state.datarow.imageId, files: data, ref: Model.endPointMedia, field:'image'}}});
    }
    
    private onError = (data: any) => {
        this.setState({errors: data});
    }
    
    private onSave = async(data: any) => {
        await this.setState({datarowPersonalinfo: {user: data.id, name: data.name, description: data.name, email: data.useremail}, save: true});
    }
    
    private onSavePersonalinfo = (data: any) => {
        this.setState({save: false});
    }

    private onChange(fieldName: string, value?: string) { 
            var username = this.state.datarow.username;
            var email = this.state.datarow.email;
            if (fieldName === 'useremail' && value) {
                email = Model.getEmailApp(value);
                username = email;
            }
    
            const nextState = {
                ...this.state, datarow: {
                    ...this.state.datarow, [fieldName]: value, email: email, username: username,
                }
            }
            this.setState(nextState);
    }

    render() {
        return (
            //editable.. 
            <>         
            <BaseCreate history={this.props.history} 
                endPoint={Model.endPointAuth + '/local/register'} model={Model} datarow={this.state.datarow} onError={this.onError} onSave={this.onSave}>              
          
                <InputSwitch name='status' label='Status' value={this.state.datarow.status} options={Model.optionStatus} error={this.state.errors?.status} onChange={this.onChange}/>
                <Input name='name' label='User Name' value={this.state.datarow.name} error={this.state.errors?.name || this.state.errors?.[0]} onChange={this.onChange} />
                <InputEmail name='useremail' label='Email' value={this.state.datarow.useremail} error={this.state.errors?.useremail} onChange={this.onChange} />
                <InputPassword name='password' label='Password' value={this.state.datarow.password} error={this.state.errors?.password} onChange={this.onChange} />
                {AppService.isAppFullVersion() &&
                <InputPicklist name='owner' label='Owner' value={this.state.datarow.owner} caption={this.state.datarow.ownerCaption} error={this.state.errors?.owner} onChange={this.onChange} >
                    <OwnerPicklist currentId={this.state.datarow.owner} onLoad={this.onLoadOwner}/>
                </InputPicklist>
                }  
                <InputFile name='imageUrl' label='Image' value={this.state.datarow.imageUrl} type='image' onLoad={this.onLoadFile} error={this.state.errors?.image} onChange={this.onChange} />
            </BaseCreate>

            <PersonalinfoCreate history={this.props.history} personalinfotypeType='customer' datarow={this.state.datarowPersonalinfo} onError={this.onError} save={this.state.save} onSave={this.onSavePersonalinfo} disableView />                            
            </>
        );
    }     
     
}